export default __webpack_public_path__ + "static/media/sample.36c11fd3.jpg";